import { Component, ComponentRef, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonServices } from '../../../domain/service/commonService';
import { GooglePlacesService } from '../../../domain/service/GooglePlaceService';
import { ProfileService } from '../../../domain/service/profileService';
import { PropertyAccountProfile } from '../../../domain/model/profile/propertyAccountProfile';
import { atLeastOneRequiredValidator } from '../../../shared/utils/atLeastOneRequiredValidator';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { Dialog } from '@angular/cdk/dialog';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { NotificationComponent } from '../../../shared/notification/notification.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { NotificationType } from '../../../domain/model/enums/notificationType';
import { HttpResponseDto } from '../../../domain/model/common/httpResponseDto';

@Component({
  selector: 'app-property-mgmt-co',
  templateUrl: './property-mgmt-co.component.html',
  styleUrl: './property-mgmt-co.component.css'
})
export class PropertyMgmtCoComponent implements OnInit, OnChanges{
  propertyMgmtCo!: FormGroup; 
  states: DropDownModel[] = [];
  @Input() data!: PropertyAccountProfile;
    dialog = inject(Dialog);
  entityRentalPropertyLicense!: FormGroup;
  reporting! : FormGroup; 
  private overlayRef!: OverlayRef;
  showNotification(message: string, title: string, notificationType: NotificationType): void {
      // Create a Portal instance of our `NotificationComponent`
      const notificationPortal = new ComponentPortal(NotificationComponent);
      // Attach our `NotificationComponent` to the Overlay Portal
      const notificationRef: ComponentRef<NotificationComponent> = this.overlayRef.attach(notificationPortal);
      // Now we can access the component instance
      // and we can pass input for the `message` prop we created.
      notificationRef.instance.message = message;
      notificationRef.instance.title = title;
      notificationRef.instance.type = notificationType;
      notificationRef.instance.overlayRef = this.overlayRef;
      notificationRef.instance.getColor();
  
      // Set a timeout to detach our component from the overlay
      // after 3000 milliseconds
      setTimeout(() => {
        this.overlayRef.detach();
      }, 10000);
    }
  constructor( private overlay: Overlay,private fb: FormBuilder, private commonServices: CommonServices,private profileServices: ProfileService, private googlePlacesService: GooglePlacesService) {

  }
  ngOnChanges(changes: SimpleChanges): void { 
    this.buildForm(this.data);
    this.propertyMgmtCo.get("printedName")?.disable();
  }
  ngOnInit(): void { 
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay.position().global().top("20px").right("30px"),
    });
    this.commonServices.getAllState(233)
      .subscribe(data => {
        this.states = data.sort((a, b) => a.name.localeCompare(b.name));
      });
 
  }

  private buildForm(data: PropertyAccountProfile | undefined): void { 
    this.propertyMgmtCo = this.fb.group({
      businessLegalName: new FormControl(data?.propertyAccountDto.businessLegalName, [Validators.required, Validators.maxLength(200)]),
      businessDbaName: new FormControl(data?.propertyAccountDto.businessDbaName),
      webUrl: new FormControl(data?.propertyAccountDto.webSiteUrl, [
        Validators.pattern(/^(https?:\/\/|www\.)[a-zA-Z0-9\-\.]+(?:\.[a-zA-Z]{2,})(?:\/[a-zA-Z0-9\-]+)*\/?$/),
      ]),
      businnesStreetAddress: new FormControl(data?.propertyAccountDto.streetAddress, [Validators.required]),
      aptUnitSuite: new FormControl(data?.propertyAccountDto.aptUnitSuite),
      city: new FormControl(data?.propertyAccountDto.city, Validators.required),
      state: new FormControl(data?.propertyAccountDto.stateId, Validators.required),
      zipCode: new FormControl(data?.propertyAccountDto.zipCode, [
        Validators.required,
        Validators.maxLength(12),
        Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/),
      ]),
      note: new FormControl(data?.propertyAccountDto.note),
      primaryContactFirstName:new FormControl(data?.propertyAccountDto.primaryContactFirstName, [Validators.required]),
      primaryContactLastName:new FormControl(data?.propertyAccountDto.primaryContactLastName, [Validators.required]),
      primaryContactEmail:new FormControl(data?.propertyAccountDto.primaryContactEmail, [Validators.required]),
      primaryContactPhone:new FormControl(data?.propertyAccountDto.primartContactPhoneNumber, [Validators.required]),
      printedName:new FormControl(data?.propertyAccountDto.account.printedName, [Validators.required]),
    });

    this.entityRentalPropertyLicense = new FormGroup(
      {
        departmentOfBusiness: new FormControl(data?.entityLicense.regulationLicenseNumber, [Validators.pattern(/^[a-zA-Z1-9][a-zA-Z0-9]*$/)]),
        taxCertificateNumber: new FormControl(data?.entityLicense.taxCertificateNumber),
        stateCertificateHasBeenApplied: new FormControl(data?.entityLicense.stateCertificateHasBeenApplied, [Validators.requiredTrue]),
        reasonWhy: new FormControl(data?.entityLicense.reasonWhy, [Validators.required]),
        certificateOfRegistration: new FormControl(data?.entityLicense.certicateOfRegistration),
        localBusinessTaxReceipt: new FormControl(data?.entityLicense.taxReceipt),
        cityOfRegistration: new FormControl(data?.entityLicense.certicateOfRegistration),
      },
      { validators: atLeastOneRequiredValidator(["reasonWhy", "stateCertificateHasBeenApplied", "taxCertificateNumber"]) }
    );

    this.reporting =this.fb.group({
      isUsingTaxRepresentative: new FormControl(data?.propertyAccountDto.isUsingTaxRepresentative),
      sendToOwner: new FormControl(data?.propertyAccountDto.correspondenceToOwner),
      sendToReportingRep: new FormControl(data?.propertyAccountDto.correspondenceToReportingRepresentative),
      taxRepresentativeFirstName: new FormControl(data?.taxRepresentative?.firstName),
      taxRepresentativeLastName: new FormControl(data?.taxRepresentative?.lastName),
      taxRepresentativeEmail: new FormControl(data?.taxRepresentative?.email),
      taxRepresentativePhoneNumber: new FormControl(data?.taxRepresentative?.phoneNumber),
      taxRepresentativeStreetAddress:new FormControl(data?.taxRepresentative?.streetAddress),
      taxRepresentativeAptUnitSuite:new FormControl(data?.taxRepresentative?.aptUnitSuite),
      taxRepresentativeCity:new FormControl(data?.taxRepresentative?.city),
      taxRepresentativeState:new FormControl(data?.taxRepresentative?.state),
      taxRepresentativeZipCode:new FormControl(data?.taxRepresentative?.zipCode),
    });
  }
     showChangePasswod(){
              const dialogRef = this.dialog.open<HttpResponseDto>(ChangePasswordComponent, {
                   width: "500px",
                   height: "510px",
                   disableClose: true, 
                 });
                  dialogRef.closed.subscribe((result) => {
                       console.log("The dialog was closed");
                       console.log(result);
                       if (result) { 
                         if (result?.error === true){
                              this.showNotification(
                             "Current password is invalid .",
                             "Change Password",
                             NotificationType.Error
                           );
                           }else {
                             this.showNotification(
                               "Password successfully changed.",
                               "Change Password",
                               NotificationType.Success
                             );
                           }
                       }
                     });
           }

           /**
            * These buttons showed "successfully updated" without saving anything (QA 2026-10-04).
            * Info and Licenses now save through one endpoint scoped to the logged-in account.
            */
           savePropertyInfo(){
            if (this.propertyMgmtCo.invalid) {
              this.propertyMgmtCo.markAllAsTouched();
              this.showNotification("Please complete the required fields.", "Profile", NotificationType.Error);
              return;
            }
            const f = this.propertyMgmtCo.getRawValue();
            const l = this.entityRentalPropertyLicense.getRawValue();
            const model = {
              businessLegalName: f.businessLegalName, businessDbaName: f.businessDbaName, webSiteUrl: f.webUrl,
              streetAddress: f.businnesStreetAddress, aptUnitSuite: f.aptUnitSuite, city: f.city, stateId: f.state,
              zipCode: f.zipCode, note: f.note,
              primaryContactFirstName: f.primaryContactFirstName, primaryContactLastName: f.primaryContactLastName,
              primaryContactEmail: f.primaryContactEmail, primaryContactPhone: f.primaryContactPhone,
              license: {
                regulationLicenseNumber: l.departmentOfBusiness, taxCertificateNumber: l.taxCertificateNumber,
                stateCertificateHasBeenApplied: l.stateCertificateHasBeenApplied, reasonWhy: l.reasonWhy,
              },
            };
            this.profileServices.updatePropertyMgmtCo(model).subscribe({
              next: () => {
                this.propertyMgmtCo.markAsPristine();
                this.entityRentalPropertyLicense.markAsPristine();
                this.showNotification("Profile successfully updated", "Profile", NotificationType.Success);
              },
              error: () => this.showNotification("Could not save your changes. Please try again.", "Profile", NotificationType.Error),
            });
           }

           /** Reporting tab now saves (QA 2026-10-05); scoped to the logged-in account server-side. */
           savePropertyReporting(){
            const r = this.reporting.getRawValue();
            const model = {
              isUsingTaxRepresentative: !!r.isUsingTaxRepresentative,
              correspondenceToOwner: r.sendToOwner, correspondenceToReportingRepresentative: r.sendToReportingRep,
              firstName: r.taxRepresentativeFirstName, lastName: r.taxRepresentativeLastName,
              email: r.taxRepresentativeEmail, phoneNumber: r.taxRepresentativePhoneNumber,
              streetAddress: r.taxRepresentativeStreetAddress, aptUnitSuite: r.taxRepresentativeAptUnitSuite,
              city: r.taxRepresentativeCity, stateId: r.taxRepresentativeState, zipCode: r.taxRepresentativeZipCode,
            };
            this.profileServices.updatePropertyMgmtReporting(model).subscribe({
              next: () => {
                this.reporting.markAsPristine();
                this.showNotification("Reporting successfully updated", "Profile", NotificationType.Success);
              },
              error: () => this.showNotification("Could not save your changes. Please try again.", "Profile", NotificationType.Error),
            });
           }

           savePropertyLicense(){
            this.savePropertyInfo();
           }
}
